import { render } from "./RFIForm.vue?vue&type=template&id=5b72137a"
import script from "./RFIForm.vue?vue&type=script&lang=js"
export * from "./RFIForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__